import { useTranslation } from 'react-i18next';

export function RevokeSuccessRoute() {
  const { t } = useTranslation('data_privacy');
  return (
    <div className="w-full max-w-2xl text-white px-4">
      <h1 className="text-md mt-16 opacity-75 capitalize">{t('consent_declaration')}</h1>
      <h2 className="font-bold text-4xl mb-8">{t('consent.successful_revoke_heading')}</h2>
      <p className="mb-8">{t('consent.successful_revoke_text')}</p>
    </div>
  );
}

export default RevokeSuccessRoute;
